// import React, { useEffect, useState } from "react";
// import Loader from "../utils/loader";
// import { makeStyles } from "@material-ui/core/styles";
// import HeadingB from "./Cards/HeadingB";
// import BreadCrumb from "./Cards/BreadCrumbs";
// import {
//     submitContactForm
// } from "../services/userService";
// import  support_illustration from "../static/support_illustration.png"
// import { toast, ToastContainer } from "react-toastify";
// import { Typography } from "@material-ui/core";
// import MenuItem from '@mui/material/MenuItem';
// import FormControl from '@mui/material/FormControl';
// import Select from '@mui/material/Select';
// import InputLabel from '@mui/material/InputLabel';
// import TextField from '@mui/material/TextField';
// import Button from '@mui/material/Button';
// import { useHistory } from 'react-router-dom';

// const useStyles = makeStyles({
//     root: {
//         minWidth: 150,
//         width: 150,
//     },
//     bullet: {
//         display: "inline-block",
//         margin: "0 2px",
//         transform: "scale(0.8)",
//     },
//     title: {
//         fontSize: 14,
//     },
//     pos: {
//         marginBottom: 12,
//     },
// });

// function ContactUs({ }) {
//     const classes = useStyles();
//     const [loading, setLoading] = useState(false);
//     const [email, setemail] = useState("");
//     const [feature, setfeature] = useState("");
//     const [message, setmessage] = useState("");

//     const history = useHistory();

//     const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 500);

//     useEffect(() => {
//       const handleResize = () => {
//         setIsMobileView(window.innerWidth <= 500);
//       };

//       // Attach event listener to window resize
//       window.addEventListener('resize', handleResize);

//       // Cleanup the event listener on component unmount
//       return () => {
//         window.removeEventListener('resize', handleResize);
//       };
//     }, []);

//     const handleGoBack = () => {
//         history.push('/dashboard');
//     };

//     const handleSubmit = async () => {
//         if (!email) {
//             toast.warn("Please Enter Email.");
//         } else if (!feature) {
//             toast.warn("Please Select Feature.");
//         } else if (!message) {
//             toast.warn("Please write message to us.");
//         }
//         else {
//             let details = {
//                 userEmail: email,
//                 selectedFeature: feature,
//                 message: message,

//             };
//             console.log(details)
//             let response = await submitContactForm(details);
//             console.log(response)
//             if (response.status === 200) {
//                 toast.success(response.message);
//             } else {
//                 toast.error(response.message);
//             }

//         }
//         setfeature("")
//         setmessage("")
//         setemail("");
//     };

//     const options = [
//         {
//             text: "Newsletter",
//             value: "newsletter",
//             icon: "sticky note outline"
//         },
//         { text: "Alerts", value: "alert", icon: "bell outline" }
//     ];

//     return (
//         <div style={{width:"100%",border:isMobileView ? "2px solid #ccc" : "",borderRadius:isMobileView ? "12px" : ""}}>

//             <BreadCrumb

//             l1="Home"
//             l2="Support"
//             dashboardlink="/dashboard"

//           />
//         <div className="container-fluid h-100" id="DocCard" style={{marginTop:isMobileView ? "-30px" : ""}}>
//             <Loader loading={loading} />
//             <ToastContainer />
//             <div className="container" style={{padding:'15px 0px',marginBottom:"10px"}} >

//                 {/* <HeadingB className="text-center alertHead pt-5" text="SUPPORT" /> */}
//                 <Typography variant="h4"><b>Support</b></Typography>
//                <div className="row">
//                    <div className="col-md-6"> <div className="mt-5">
//                     <TextField
//                         id="introTitle"
//                         label="Email"
//                         variant="outlined"
//                         placeholder="Enter Email ID"
//                         style={{ width: '100%' }}
//                         onChange={(e) => setemail(e.target.value)}
//                         value={email || ""}
//                         name="Email"
//                         InputProps={{ inputProps: { maxLength: 50, type: "email" } }}
//                         className="mt-2"
//                     />

//                 </div>

//                 <div className="mt-5">
//                 <FormControl style={{ width: '100%' }}>
//                         <InputLabel id="demo-simple-select-label">Reason</InputLabel>
//                         <Select
//                             labelId="demo-simple-select-label"
//                             value={feature}
//                             onChange={(e) => setfeature(e.target.value)}
//                             label="Reason"
//                         >
//                             <MenuItem value="">
//                                 <em>Choose your option</em>
//                             </MenuItem>
//                             <MenuItem value="textEditor">Text Editor</MenuItem>
//                             <MenuItem value="teams">Teams</MenuItem>
//                             <MenuItem value="blogs">Blogs</MenuItem>
//                             <MenuItem value="citation">Citation</MenuItem>
//                             <MenuItem value="paraphrasing">Paraphrasing</MenuItem>
//                             <MenuItem value="plagarism">Plagiarism</MenuItem>
//                             <MenuItem value="reports">Reports</MenuItem>
//                             <MenuItem value="subscription">Subscription</MenuItem>
//                             <MenuItem value="invoices">Invoices</MenuItem>
//                             <MenuItem value="other">Other</MenuItem>
//                         </Select>
//                     </FormControl>
//                 </div>

//                 <div className="mt-5">
//                     <TextField
//                         id="introSubtext"
//                         label="Description"
//                         variant="outlined"
//                         placeholder="Write here! We are listening..."
//                         style={{width:'100%'}}
//                         onChange={(e) => setmessage(e.target.value)}
//                         value={message || ""}
//                         name="Project_subtext"
//                         InputProps={{ inputProps: { maxLength: 350 } }}
//                         multiline
//                         rows={6}

//                     />

//                 </div>

//                 <div className="mt-3 text-center" style={{width:"95%",margin:"auto",borderRadius:"10px"}}>

//                 <Button variant="outlined" color='error' style={{marginRight:'20px'}} onClick={handleGoBack}>Cancel</Button>
//                 <Button variant="contained" color='primary'  onClick={handleSubmit}>Submit</Button>

//                     {/* <button
//                         className="btn btn-primary mb-4"
//                         type="submit"
//                         id="backBtn"
//                         onClick={handleSubmit}
//                         style={{
//                             width: "20%",
//                         }}
//                     // disabled={buttonDisable}
//                     >
//                         Submit
//           </button> */}
//                 </div>
//                 </div>
//                 {!isMobileView ? <>
//                     <div className="col-md-6">
//                 <img
//                 src={support_illustration}
//                 style={{ width: "100%", height: "100%" }}
//                 alt="Contact Us"
//               />
//                 </div>
//                 </> : <>

//                 </>}

//                </div>
//             </div>
//         </div>
//         </div>
//     );
// }
// export default ContactUs;


// import React, { useEffect, useState } from "react";
// import Loader from "../utils/loader";
// import { submitContactForm } from "../services/userService";
// import support_illustration from "../static/support_illustration.png";
// import { toast, ToastContainer } from "react-toastify";
// import {
//   Typography,
//   TextField,
//   Button,
//   MenuItem,
//   FormControl,
//   Select,
//   Box,
//   Avatar,
//   Chip,
//   Divider,
//   Paper,
//   alpha,
// } from "@mui/material";
// import Grid2 from "@mui/material/Unstable_Grid2";
// import {
//   SupportAgent as SupportAgentIcon,
//   Send as SendIcon,
//   ArrowBack as ArrowBackIcon,
//   Email as EmailIcon,
//   Category as CategoryIcon,
//   Description as DescriptionIcon,
//   CheckCircleOutline as CheckCircleOutlineIcon,
// } from "@mui/icons-material";
// import { useHistory } from "react-router-dom";
// import { createTheme, ThemeProvider } from "@mui/material/styles";

// // ── Theme ──────────────────────────────────────────────────────────────────────
// const theme = createTheme({
//   palette: {
//     mode: "light",
//     primary: { main: "#5C6BC0" },
//     secondary: { main: "#26C6DA" },
//     background: { default: "#F4F6FB", paper: "#FFFFFF" },
//     text: { primary: "#1A1D2E", secondary: "#6B7280" },
//     error: { main: "#EF5350" },
//   },
//   typography: {
//     fontFamily: "'DM Sans', 'Nunito', sans-serif",
//     h4: { fontWeight: 800, letterSpacing: "-0.5px" },
//     h5: { fontWeight: 700 },
//     h6: { fontWeight: 600 },
//     body2: { color: "#6B7280" },
//   },
//   shape: { borderRadius: 14 },
//   components: {
//     MuiOutlinedInput: {
//       styleOverrides: {
//         root: {
//           borderRadius: 12,
//           backgroundColor: "#F8F9FD",
//           "&:hover .MuiOutlinedInput-notchedOutline": {
//             borderColor: "#5C6BC0",
//           },
//         },
//       },
//     },
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           borderRadius: 10,
//           textTransform: "none",
//           fontWeight: 700,
//           fontSize: "0.95rem",
//           padding: "10px 28px",
//         },
//       },
//     },
//     MuiSelect: {
//       styleOverrides: {
//         root: { borderRadius: 12, backgroundColor: "#F8F9FD" },
//       },
//     },
//   },
// });

// // ── Reason options ─────────────────────────────────────────────────────────────
// const REASON_OPTIONS = [
//   { value: "textEditor", label: "Text Editor", emoji: "✏️" },
//   { value: "teams", label: "Teams", emoji: "👥" },
//   { value: "blogs", label: "Blogs", emoji: "📝" },
//   { value: "citation", label: "Citation", emoji: "📚" },
//   { value: "paraphrasing", label: "Paraphrasing", emoji: "🔄" },
//   { value: "plagarism", label: "Plagiarism", emoji: "🔍" },
//   { value: "reports", label: "Reports", emoji: "📊" },
//   { value: "subscription", label: "Subscription", emoji: "💳" },
//   { value: "invoices", label: "Invoices", emoji: "🧾" },
//   { value: "other", label: "Other", emoji: "💬" },
// ];
// function FieldLabel({ icon, label }) {
//   return (
//     <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
//       {React.cloneElement(icon, {
//         sx: { fontSize: 18, color: "primary.main" },
//       })}
//       <Typography variant="body2" fontWeight={600} color="text.primary">
//         {label}
//       </Typography>
//     </Box>
//   );
// }

// // ── Main Component ─────────────────────────────────────────────────────────────
// function ContactUs() {
//   const [loading, setLoading] = useState(false);
//   const [email, setemail] = useState("");
//   const [feature, setfeature] = useState("");
//   const [message, setmessage] = useState("");
//   const [submitted, setSubmitted] = useState(false);
//   const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 600);

//   const history = useHistory();

//   useEffect(() => {
//     const handleResize = () => setIsMobileView(window.innerWidth <= 600);
//     window.addEventListener("resize", handleResize);
//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   const handleGoBack = () => history.push("/dashboard");

//   const handleSubmit = async () => {
//     if (!email) return toast.warn("Please enter your email.");
//     if (!feature) return toast.warn("Please select a reason.");
//     if (!message) return toast.warn("Please write a message.");

//     setLoading(true);
//     try {
//       const details = { userEmail: email, selectedFeature: feature, message };
//       const response = await submitContactForm(details);
//       if (response.status === 200) {
//         toast.success(response.message);
//         setSubmitted(true);
//       } else {
//         toast.error(response.message);
//       }
//     } finally {
//       setLoading(false);
//       setfeature("");
//       setmessage("");
//       setemail("");
//     }
//   };

//   const handleReset = () => setSubmitted(false);

//   return (
//     <ThemeProvider theme={theme}>
//       <Box
//         sx={{
//           minHeight: "100vh",
//           background:
//             "linear-gradient(135deg, #EEF0FB 0%, #F4F6FB 60%, #E8F4FD 100%)",
//           py: { xs: 2, md: 3 },
//           px: { xs: 2, md: 3 },
//         }}
//       >
//         <Loader loading={loading} />
//         <ToastContainer position="top-right" autoClose={3000} />

//         {/* Breadcrumb nav */}
//         <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 3 }}>
//           <Button
//             startIcon={<ArrowBackIcon />}
//             onClick={handleGoBack}
//             size="small"
//             sx={{
//               color: "text.secondary",
//               fontWeight: 600,
//               fontSize: "0.85rem",
//               "&:hover": {
//                 color: "primary.main",
//                 background: alpha("#5C6BC0", 0.07),
//               },
//             }}
//           >
//             Dashboard
//           </Button>
//           <Typography color="text.secondary" sx={{ fontSize: "0.85rem" }}>
//             /
//           </Typography>
//           <Typography
//             color="primary.main"
//             fontWeight={700}
//             sx={{ fontSize: "0.85rem" }}
//           >
//             Support
//           </Typography>
//         </Box>

//         <Grid2 container spacing={4} alignItems="flex-start">
//           {/* ── Left: Form Card ──────────────────────────────────────────── */}
//           <Grid2 xs={12} md={7} lg={6}>
//             <Paper
//               elevation={0}
//               sx={{
//                 borderRadius: 4,
//                 border: "1.5px solid",
//                 borderColor: alpha("#5C6BC0", 0.12),
//                 boxShadow: "0 8px 40px rgba(92,107,192,0.10)",
//                 overflow: "hidden",
//               }}
//             >
//               {/* Card Header */}
//               <Box
//                 sx={{
//                   background:
//                     "linear-gradient(135deg, #5C6BC0 0%, #3F51B5 100%)",
//                   px: 4,
//                   py: 3,
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 2,
//                 }}
//               >
//                 <Avatar
//                   sx={{ bgcolor: alpha("#fff", 0.2), width: 48, height: 48 }}
//                 >
//                   <SupportAgentIcon sx={{ color: "#fff", fontSize: 26 }} />
//                 </Avatar>
//                 <Box>
//                   <Typography variant="h5" color="white" fontWeight={800}>
//                     Contact Support
//                   </Typography>
//                   <Typography
//                     variant="body2"
//                     sx={{ color: alpha("#fff", 0.75), mt: 0.3 }}
//                   >
//                     We typically respond within 24 hours
//                   </Typography>
//                 </Box>
//                 <Chip
//                   label="● Online"
//                   size="small"
//                   sx={{
//                     ml: "auto",
//                     bgcolor: alpha("#4CAF50", 0.2),
//                     color: "#A5D6A7",
//                     fontWeight: 700,
//                     fontSize: "0.75rem",
//                     border: "1px solid",
//                     borderColor: alpha("#4CAF50", 0.3),
//                   }}
//                 />
//               </Box>

//               {/* Card Body */}
//               {!submitted ? (
//                 <Box sx={{ px: { xs: 3, md: 4 }, py: 4 }}>
//                   <Grid2 container spacing={3}>
//                     {/* Email */}
//                     <Grid2 xs={12}>
//                       <FieldLabel
//                         icon={<EmailIcon />}
//                         label="Your Email Address"
//                       />
//                       <TextField
//                         fullWidth
//                         placeholder="you@example.com"
//                         variant="outlined"
//                         value={email}
//                         onChange={(e) => setemail(e.target.value)}
//                         inputProps={{ maxLength: 50, type: "email" }}
//                       />
//                     </Grid2>

//                     {/* Reason */}
//                     <Grid2 xs={12}>
//                       <FieldLabel
//                         icon={<CategoryIcon />}
//                         label="Reason for Contact"
//                       />
//                       <FormControl fullWidth>
//                         <Select
//                           value={feature}
//                           onChange={(e) => setfeature(e.target.value)}
//                           displayEmpty
//                           MenuProps={{
//                             PaperProps: {
//                               sx: {
//                                 maxHeight: 150, 
//                                 overflowY: "auto",
//                                 borderRadius: 1,
//                               },
//                             },
//                           }}
//                           renderValue={(val) => {
//                             if (!val)
//                               return (
//                                 <Typography
//                                   color="text.secondary"
//                                   fontSize="0.95rem"
//                                 >
//                                   Select a topic…
//                                 </Typography>
//                               );
//                             const found = REASON_OPTIONS.find(
//                               (o) => o.value === val,
//                             );
//                             return found
//                               ? `${found.emoji}  ${found.label}`
//                               : val;
//                           }}
//                         >
//                           {REASON_OPTIONS.map((opt) => (
//                             <MenuItem key={opt.value} value={opt.value}>
//                               <Box
//                                 sx={{
//                                   display: "flex",
//                                   alignItems: "center",
//                                   gap: 1.5,
//                                 }}
//                               >
//                                 <span style={{ fontSize: "1.1rem" }}>
//                                   {opt.emoji}
//                                 </span>
//                                 <Typography fontWeight={500}>
//                                   {opt.label}
//                                 </Typography>
//                               </Box>
//                             </MenuItem>
//                           ))}
//                         </Select>
//                       </FormControl>
//                     </Grid2>

//                     {/* Message */}
//                     <Grid2 xs={12}>
//                       <FieldLabel icon={<DescriptionIcon />} label="Message" />
//                       <TextField
//                         fullWidth
//                         placeholder="Tell us what's on your mind — we're all ears!"
//                         variant="outlined"
//                         multiline
//                         rows={5}
//                         value={message}
//                         onChange={(e) => setmessage(e.target.value)}
//                         inputProps={{ maxLength: 350 }}
//                       />
//                       <Typography
//                         variant="caption"
//                         color="text.secondary"
//                         sx={{ mt: 0.5, display: "block", textAlign: "right" }}
//                       >
//                         {message.length}/350
//                       </Typography>
//                     </Grid2>

//                     {/* Actions */}
//                     <Grid2 xs={12}>
//                       <Divider
//                         sx={{ mb: 2, borderColor: alpha("#5C6BC0", 0.08) }}
//                       />
//                       <Box
//                         sx={{
//                           display: "flex",
//                           gap: 2,
//                           justifyContent: "flex-end",
//                         }}
//                       >
//                         <Button
//                           variant="outlined"
//                           color="inherit"
//                           onClick={handleGoBack}
//                           sx={{
//                             color: "text.secondary",
//                             borderColor: alpha("#1A1D2E", 0.18),
//                             "&:hover": {
//                               borderColor: "error.main",
//                               color: "error.main",
//                             },
//                           }}
//                         >
//                           Cancel
//                         </Button>
//                         <Button
//                           variant="contained"
//                           endIcon={<SendIcon />}
//                           onClick={handleSubmit}
//                           disableElevation
//                           sx={{
//                             background:
//                               "linear-gradient(135deg, #5C6BC0, #3F51B5)",
//                             "&:hover": {
//                               background:
//                                 "linear-gradient(135deg, #3F51B5, #303F9F)",
//                             },
//                           }}
//                         >
//                           Submit Ticket
//                         </Button>
//                       </Box>
//                     </Grid2>
//                   </Grid2>
//                 </Box>
//               ) : (
//                 /* ── Success State ── */
//                 <Box
//                   sx={{
//                     px: 4,
//                     py: 6,
//                     textAlign: "center",
//                     display: "flex",
//                     flexDirection: "column",
//                     alignItems: "center",
//                     gap: 2,
//                   }}
//                 >
//                   <Avatar
//                     sx={{
//                       bgcolor: alpha("#4CAF50", 0.12),
//                       width: 72,
//                       height: 72,
//                       mb: 1,
//                     }}
//                   >
//                     <CheckCircleOutlineIcon
//                       sx={{ fontSize: 40, color: "#4CAF50" }}
//                     />
//                   </Avatar>
//                   <Typography
//                     variant="h5"
//                     fontWeight={800}
//                     color="text.primary"
//                   >
//                     Message Sent!
//                   </Typography>
//                   <Typography
//                     variant="body1"
//                     color="text.secondary"
//                     maxWidth={320}
//                   >
//                     Thanks for reaching out. Our support team will get back to
//                     you within 24 hours.
//                   </Typography>
//                   <Button
//                     variant="contained"
//                     onClick={handleReset}
//                     disableElevation
//                     sx={{
//                       mt: 2,
//                       background: "linear-gradient(135deg, #5C6BC0, #3F51B5)",
//                     }}
//                   >
//                     Send Another Message
//                   </Button>
//                 </Box>
//               )}
//             </Paper>
//           </Grid2>

//           {/* ── Right: Illustration + Info Cards ──────────────────────── */}
//           {!isMobileView && (
//             <Grid2 xs={12} md={5} lg={6}>
//               <Box sx={{ pl: { md: 2 } }}>
//                 {/* Illustration box */}
//                 <Box
//                   sx={{
//                     borderRadius: 4,
//                     overflow: "hidden",
//                     mb: 3,
//                     background: alpha("#5C6BC0", 0.05),
//                     p: 3,
//                     display: "flex",
//                     justifyContent: "center",
//                     border: "1.5px solid",
//                     borderColor: alpha("#5C6BC0", 0.1),
//                   }}
//                 >
//                   <img
//                     src={support_illustration}
//                     alt="Support Illustration"
//                     style={{ width: "85%", maxWidth: 340, display: "block" }}
//                   />
//                 </Box>

//                 {/* Info cards */}
//                 <Grid2 container spacing={2}>
//                   {[
//                     {
//                       emoji: "⚡",
//                       title: "Fast Response",
//                       desc: "Average reply time under 4 hours during business days.",
//                     },
//                     {
//                       emoji: "🔒",
//                       title: "Secure & Private",
//                       desc: "Your data is encrypted and never shared with third parties.",
//                     },
//                     {
//                       emoji: "🌍",
//                       title: "24/7 Coverage",
//                       desc: "Global support team available around the clock.",
//                     },
//                   ].map((card) => (
//                     <Grid2 xs={12} key={card.title}>
//                       <Paper
//                         elevation={0}
//                         sx={{
//                           p: 2.5,
//                           borderRadius: 3,
//                           border: "1.5px solid",
//                           borderColor: alpha("#5C6BC0", 0.1),
//                           display: "flex",
//                           alignItems: "flex-start",
//                           gap: 2,
//                           transition: "box-shadow 0.2s, transform 0.2s",
//                           "&:hover": {
//                             boxShadow: "0 6px 24px rgba(92,107,192,0.12)",
//                             transform: "translateY(-2px)",
//                           },
//                         }}
//                       >
//                         <Box
//                           sx={{
//                             fontSize: "1.4rem",
//                             width: 44,
//                             height: 44,
//                             display: "flex",
//                             alignItems: "center",
//                             justifyContent: "center",
//                             borderRadius: 2,
//                             bgcolor: alpha("#5C6BC0", 0.08),
//                             flexShrink: 0,
//                           }}
//                         >
//                           {card.emoji}
//                         </Box>
//                         <Box>
//                           <Typography
//                             variant="body1"
//                             fontWeight={700}
//                             color="text.primary"
//                           >
//                             {card.title}
//                           </Typography>
//                           <Typography
//                             variant="body2"
//                             color="text.secondary"
//                             mt={0.3}
//                           >
//                             {card.desc}
//                           </Typography>
//                         </Box>
//                       </Paper>
//                     </Grid2>
//                   ))}
//                 </Grid2>
//               </Box>
//             </Grid2>
//           )}
//         </Grid2>
//       </Box>
//     </ThemeProvider>
//   );
// }

// export default ContactUs;




import React, { useEffect, useState, useRef } from "react";
import Loader from "../utils/loader";
import { submitContactForm } from "../services/userService";
import support_illustration from "../static/support_illustration.png";
import { toast, ToastContainer } from "react-toastify";
import {
  Typography,
  TextField,
  Button,
  MenuItem,
  FormControl,
  Select,
  Box,
  Avatar,
  Chip,
  Divider,
  Paper,
  alpha,
} from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2";
import {
  SupportAgent as SupportAgentIcon,
  Send as SendIcon,
  ArrowBack as ArrowBackIcon,
  Email as EmailIcon,
  Category as CategoryIcon,
  Description as DescriptionIcon,
  CheckCircleOutline as CheckCircleOutlineIcon,
} from "@mui/icons-material";
import { useHistory } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";

// ── Light Theme 3D Animated Background ─────────────────────────────────────────
const LightThemeBackground3D = () => {
  const canvasRef = useRef(null);
  
  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    let animationFrame;
    let particles = [];
    let mouseX = 0;
    let mouseY = 0;
    
    // Track mouse movement for interactive effect
    const handleMouseMove = (e) => {
      mouseX = (e.clientX / window.innerWidth - 0.5) * 2;
      mouseY = (e.clientY / window.innerHeight - 0.5) * 2;
    };
    
    window.addEventListener('mousemove', handleMouseMove);
    
    // Particle class for 3D effect - Light theme colors
    class Particle {
      constructor() {
        this.reset();
      }
      
      reset() {
        // Position in 3D space
        this.x = (Math.random() - 0.5) * 200;
        this.y = (Math.random() - 0.5) * 200;
        this.z = (Math.random() - 0.5) * 200;
        
        // Size and opacity based on z-index for depth
        this.size = Math.random() * 4 + 1;
        this.baseSize = this.size;
        
        // Movement speed
        this.speedX = (Math.random() - 0.5) * 0.3;
        this.speedY = (Math.random() - 0.5) * 0.3;
        this.speedZ = (Math.random() - 0.5) * 0.3;
        
        // Light theme colors - soft pastels
        const colors = [
          { r: 92, g: 107, b: 192, a: 0.3 },  // soft purple
          { r: 38, g: 198, b: 218, a: 0.25 }, // soft cyan
          { r: 255, g: 193, b: 7, a: 0.2 },   // soft yellow
          { r: 255, g: 138, b: 128, a: 0.2 }, // soft coral
          { r: 163, g: 190, b: 140, a: 0.2 }, // soft green
        ];
        const color = colors[Math.floor(Math.random() * colors.length)];
        this.color = `rgba(${color.r}, ${color.g}, ${color.b}, ${color.a})`;
      }
      
      update() {
        // Move particles in 3D space
        this.x += this.speedX;
        this.y += this.speedY;
        this.z += this.speedZ;
        
        // Reset if too far
        if (Math.abs(this.x) > 150 || Math.abs(this.y) > 150 || Math.abs(this.z) > 150) {
          this.reset();
        }
        
        // Interactive effect - particles gently move away from mouse
        const distance = Math.sqrt(
          Math.pow(this.x - mouseX * 40, 2) + 
          Math.pow(this.y - mouseY * 40, 2)
        );
        if (distance < 60) {
          const angle = Math.atan2(this.y - mouseY * 40, this.x - mouseX * 40);
          this.x += Math.cos(angle) * 1;
          this.y += Math.sin(angle) * 1;
        }
      }
      
      draw(ctx, width, height) {
        // Project 3D to 2D
        const scale = 600 / (600 + this.z);
        const x2d = width / 2 + this.x * scale;
        const y2d = height / 2 + this.y * scale;
        
        // Only draw if in view
        if (x2d > 0 && x2d < width && y2d > 0 && y2d < height) {
          // Size based on z-distance for depth effect
          const size = this.baseSize * scale;
          
          // Opacity based on z-distance
          const opacity = Math.max(0.1, 0.4 - Math.abs(this.z) / 500);
          
          ctx.beginPath();
          ctx.arc(x2d, y2d, size, 0, Math.PI * 2);
          ctx.fillStyle = this.color.replace(/[\d\.]+\)$/g, `${opacity})`);
          ctx.fill();
          
          // Add soft glow effect
          ctx.shadowColor = this.color;
          ctx.shadowBlur = 10;
          ctx.fill();
          ctx.shadowBlur = 0;
        }
      }
    }
    
    // Initialize particles
    for (let i = 0; i < 80; i++) {
      particles.push(new Particle());
    }
    
    const resize = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    
    const animate = () => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      
      // Update and draw particles
      particles.forEach(particle => {
        particle.update();
        particle.draw(ctx, canvas.width, canvas.height);
      });
      
      // Draw connecting lines between nearby particles - very subtle
      ctx.strokeStyle = 'rgba(92, 107, 192, 0.03)';
      ctx.lineWidth = 0.5;
      
      for (let i = 0; i < particles.length; i++) {
        for (let j = i + 1; j < particles.length; j++) {
          const p1 = particles[i];
          const p2 = particles[j];
          
          // Calculate 2D positions
          const scale1 = 600 / (600 + p1.z);
          const x1 = canvas.width / 2 + p1.x * scale1;
          const y1 = canvas.height / 2 + p1.y * scale1;
          
          const scale2 = 600 / (600 + p2.z);
          const x2 = canvas.width / 2 + p2.x * scale2;
          const y2 = canvas.height / 2 + p2.y * scale2;
          
          // Calculate distance
          const distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
          
          // Draw line if close enough
          if (distance < 80) {
            ctx.beginPath();
            ctx.moveTo(x1, y1);
            ctx.lineTo(x2, y2);
            ctx.strokeStyle = `rgba(92, 107, 192, ${0.02 * (1 - distance / 80)})`;
            ctx.stroke();
          }
        }
      }
      
      animationFrame = requestAnimationFrame(animate);
    };
    
    window.addEventListener('resize', resize);
    resize();
    animate();
    
    return () => {
      window.removeEventListener('resize', resize);
      window.removeEventListener('mousemove', handleMouseMove);
      cancelAnimationFrame(animationFrame);
    };
  }, []);
  
  return (
    <>
      <canvas
        ref={canvasRef}
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          zIndex: 0,
          pointerEvents: 'none',
          background: 'linear-gradient(145deg, #FFFFFF 0%, #F8FAFF 50%, #F0F4FF 100%)',
        }}
      />
      
      {/* Floating 3D icons - Light theme */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 0,
          pointerEvents: 'none',
          overflow: 'hidden',
        }}
      >
        {/* Floating support icons with soft colors */}
        {[
          { icon: '✏️', color: '#5C6BC0', left: '5%', top: '15%', delay: 0 },
          { icon: '👥', color: '#26C6DA', left: '85%', top: '25%', delay: 2 },
          { icon: '📝', color: '#FFC107', left: '15%', top: '75%', delay: 4 },
          { icon: '📚', color: '#FF8A80', left: '75%', top: '80%', delay: 1 },
          { icon: '🔄', color: '#A3BE8C', left: '45%', top: '10%', delay: 3 },
          { icon: '🔍', color: '#5C6BC0', left: '25%', top: '45%', delay: 5 },
          { icon: '📊', color: '#26C6DA', left: '65%', top: '55%', delay: 2.5 },
          { icon: '💳', color: '#FFC107', left: '55%', top: '30%', delay: 3.5 },
          { icon: '💬', color: '#FF8A80', left: '35%', top: '85%', delay: 4.5 },
        ].map((item, index) => (
          <Box
            key={index}
            sx={{
              position: 'absolute',
              left: item.left,
              top: item.top,
              fontSize: '2.5rem',
              opacity: 0.15,
              animation: `floatSoft ${12 + index * 2}s infinite ease-in-out ${item.delay}s`,
              filter: 'drop-shadow(0 4px 8px rgba(92,107,192,0.1))',
              color: item.color,
              transform: 'translateZ(0)',
              '@keyframes floatSoft': {
                '0%, 100%': {
                  transform: 'translate(0, 0) rotate(0deg) scale(1)',
                },
                '25%': {
                  transform: 'translate(15px, -15px) rotate(5deg) scale(1.05)',
                },
                '50%': {
                  transform: 'translate(-10px, 10px) rotate(-5deg) scale(0.95)',
                },
                '75%': {
                  transform: 'translate(10px, 15px) rotate(3deg) scale(1.02)',
                },
              },
            }}
          >
            {item.icon}
          </Box>
        ))}
      </Box>
      
      {/* Soft gradient orbs for depth */}
      <Box
        sx={{
          position: 'fixed',
          top: '-20%',
          left: '-10%',
          width: '60%',
          height: '60%',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(92,107,192,0.08) 0%, transparent 70%)',
          filter: 'blur(60px)',
          zIndex: 0,
          pointerEvents: 'none',
        }}
      />
      <Box
        sx={{
          position: 'fixed',
          bottom: '-20%',
          right: '-10%',
          width: '70%',
          height: '70%',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(38,198,218,0.08) 0%, transparent 70%)',
          filter: 'blur(60px)',
          zIndex: 0,
          pointerEvents: 'none',
        }}
      />
      <Box
        sx={{
          position: 'fixed',
          top: '40%',
          right: '20%',
          width: '40%',
          height: '40%',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(255,193,7,0.05) 0%, transparent 70%)',
          filter: 'blur(50px)',
          zIndex: 0,
          pointerEvents: 'none',
        }}
      />
      
      {/* Light sparkles */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          zIndex: 0,
          pointerEvents: 'none',
          background: 'radial-gradient(circle at 50% 50%, rgba(255,255,255,0.3) 0%, transparent 60%)',
        }}
      />
    </>
  );
};

// ── Light Theme Configuration ─────────────────────────────────────────────────
const lightTheme = createTheme({
  palette: {
    mode: "light",
    primary: { main: "#5C6BC0" },
    secondary: { main: "#26C6DA" },
    background: { 
      default: "#F8FAFF", 
      paper: "#FFFFFF" 
    },
    text: { 
      primary: "#1A1D2E", 
      secondary: "#6B7280" 
    },
    error: { main: "#EF5350" },
    success: { main: "#4CAF50" },
  },
  typography: {
    fontFamily: "'DM Sans', 'Nunito', sans-serif",
    h4: { fontWeight: 800, letterSpacing: "-0.5px" },
    h5: { fontWeight: 700 },
    h6: { fontWeight: 600 },
    body2: { color: "#6B7280" },
  },
  shape: { borderRadius: 16 },
  components: {
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 14,
          backgroundColor: "#FFFFFF",
          transition: 'all 0.3s ease',
          boxShadow: '0 2px 8px rgba(0,0,0,0.02)',
          "&:hover": {
            boxShadow: '0 4px 12px rgba(92,107,192,0.08)',
          },
          "&.Mui-focused": {
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 20px rgba(92,107,192,0.12)',
          },
          "& .MuiOutlinedInput-notchedOutline": {
            borderColor: "#E0E7FF",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          textTransform: "none",
          fontWeight: 700,
          fontSize: "0.95rem",
          padding: "10px 28px",
          transition: 'all 0.3s ease',
          '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 20px rgba(92,107,192,0.2)',
          },
        },
        contained: {
          boxShadow: '0 4px 12px rgba(92,107,192,0.15)',
        },
      },
    },
    MuiSelect: {
      styleOverrides: {
        root: { 
          borderRadius: 14, 
          backgroundColor: "#FFFFFF",
          transition: 'all 0.3s ease',
          boxShadow: '0 2px 8px rgba(0,0,0,0.02)',
          "&:hover": {
            boxShadow: '0 4px 12px rgba(92,107,192,0.08)',
          },
          "&.Mui-focused": {
            transform: 'translateY(-2px)',
            boxShadow: '0 8px 20px rgba(92,107,192,0.12)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          transition: 'transform 0.3s ease, box-shadow 0.3s ease',
          '&:hover': {
            transform: 'translateY(-4px)',
            boxShadow: '0 20px 40px rgba(92,107,192,0.1)',
          },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
  },
});

// ── Reason options ─────────────────────────────────────────────────────────────
const REASON_OPTIONS = [
  { value: "textEditor", label: "Text Editor", emoji: "✏️", color: "#5C6BC0" },
  { value: "teams", label: "Teams", emoji: "👥", color: "#26C6DA" },
  { value: "blogs", label: "Blogs", emoji: "📝", color: "#FFC107" },
  { value: "citation", label: "Citation", emoji: "📚", color: "#FF8A80" },
  { value: "paraphrasing", label: "Paraphrasing", emoji: "🔄", color: "#A3BE8C" },
  { value: "plagarism", label: "Plagiarism", emoji: "🔍", color: "#5C6BC0" },
  { value: "reports", label: "Reports", emoji: "📊", color: "#26C6DA" },
  { value: "subscription", label: "Subscription", emoji: "💳", color: "#FFC107" },
  { value: "invoices", label: "Invoices", emoji: "🧾", color: "#FF8A80" },
  { value: "other", label: "Other", emoji: "💬", color: "#A3BE8C" },
];

function FieldLabel({ icon, label, color = "primary.main" }) {
  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1 }}>
      {React.cloneElement(icon, {
        sx: { fontSize: 18, color: color },
      })}
      <Typography variant="body2" fontWeight={600} color="text.primary">
        {label}
      </Typography>
    </Box>
  );
}

// ── Main Component ─────────────────────────────────────────────────────────────
function ContactUs() {
  const [loading, setLoading] = useState(false);
  const [email, setemail] = useState("");
  const [feature, setfeature] = useState("");
  const [message, setmessage] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [isMobileView, setIsMobileView] = useState(window.innerWidth <= 600);

  const history = useHistory();

  useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth <= 600);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleGoBack = () => history.push("/dashboard");

  const handleSubmit = async () => {
    if (!email) return toast.warn("Please enter your email.");
    if (!feature) return toast.warn("Please select a reason.");
    if (!message) return toast.warn("Please write a message.");

    setLoading(true);
    try {
      const details = { userEmail: email, selectedFeature: feature, message };
      const response = await submitContactForm(details);
      if (response.status === 200) {
        toast.success(response.message);
        setSubmitted(true);
      } else {
        toast.error(response.message);
      }
    } finally {
      setLoading(false);
      setfeature("");
      setmessage("");
      setemail("");
    }
  };

  const handleReset = () => setSubmitted(false);

  return (
    <ThemeProvider theme={lightTheme}>
      {/* Light Theme 3D Animated Background */}
      <LightThemeBackground3D />
      
      {/* Main Content */}
      <Box
        sx={{
          minHeight: "100vh",
          position: "relative",
          zIndex: 1,
          py: { xs: 2, md: 4 },
          px: { xs: 2, md: 4 },
        }}
      >
        <Loader loading={loading} />
        <ToastContainer 
          position="top-right" 
          autoClose={3000}
          toastStyle={{
            borderRadius: '14px',
            boxShadow: '0 8px 20px rgba(0,0,0,0.05)',
            backgroundColor: '#FFFFFF',
            color: '#1A1D2E',
          }}
        />

        {/* Breadcrumb nav */}
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 4 }}>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={handleGoBack}
            size="small"
            sx={{
              color: "#5C6BC0",
              fontWeight: 600,
              fontSize: "0.85rem",
              backgroundColor: "rgba(255,255,255,0.7)",
              backdropFilter: 'blur(10px)',
              boxShadow: '0 2px 8px rgba(92,107,192,0.05)',
              "&:hover": {
                backgroundColor: "#FFFFFF",
                transform: 'translateX(-2px)',
                boxShadow: '0 4px 12px rgba(92,107,192,0.1)',
              },
            }}
          >
            Dashboard
          </Button>
          <Typography color="#6B7280" sx={{ fontSize: "0.85rem" }}>
            /
          </Typography>
          <Typography
            color="#5C6BC0"
            fontWeight={700}
            sx={{ fontSize: "0.85rem" }}
          >
            Support
          </Typography>
        </Box>

        <Grid2 container spacing={4} alignItems="flex-start">
          {/* ── Left: Form Card ──────────────────────────────────────────── */}
          <Grid2 xs={12} md={7} lg={6}>
            <Paper
              elevation={0}
              sx={{
                borderRadius: 4,
                border: "1px solid",
                borderColor: "rgba(92,107,192,0.1)",
                boxShadow: "0 20px 60px rgba(92,107,192,0.08)",
                overflow: "hidden",
                backdropFilter: "blur(10px)",
                background: "rgba(255,255,255,0.95)",
                animation: "slideIn 0.5s ease-out",
                '@keyframes slideIn': {
                  from: {
                    opacity: 0,
                    transform: 'translateX(-20px)',
                  },
                  to: {
                    opacity: 1,
                    transform: 'translateX(0)',
                  },
                },
                transition: 'all 0.3s ease',
                "&:hover": {
                  boxShadow: "0 30px 70px rgba(92,107,192,0.12)",
                  transform: 'translateY(-2px)',
                },
              }}
            >
              {/* Card Header */}
              <Box
                sx={{
                  background: "linear-gradient(135deg, #5C6BC0 0%, #7E8CD6 100%)",
                  px: 4,
                  py: 3,
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                }}
              >
                <Avatar
                  sx={{ 
                    bgcolor: "rgba(255,255,255,0.2)", 
                    width: 48, 
                    height: 48,
                    animation: 'softPulse 3s infinite',
                    '@keyframes softPulse': {
                      '0%': { boxShadow: '0 0 0 0 rgba(255,255,255,0.4)' },
                      '70%': { boxShadow: '0 0 0 8px rgba(255,255,255,0)' },
                      '100%': { boxShadow: '0 0 0 0 rgba(255,255,255,0)' },
                    },
                  }}
                >
                  <SupportAgentIcon sx={{ color: "#fff", fontSize: 26 }} />
                </Avatar>
                <Box>
                  <Typography variant="h5" color="white" fontWeight={800}>
                    Contact Support
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{ color: "rgba(255,255,255,0.9)", mt: 0.3 }}
                  >
                    We typically respond within 24 hours
                  </Typography>
                </Box>
                <Chip
                  label="● Online"
                  size="small"
                  sx={{
                    ml: "auto",
                    bgcolor: "rgba(76, 175, 80, 0.2)",
                    color: "#E8F5E9",
                    fontWeight: 700,
                    fontSize: "0.75rem",
                    border: "1px solid",
                    borderColor: "rgba(76, 175, 80, 0.3)",
                  }}
                />
              </Box>

              {/* Card Body */}
              {!submitted ? (
                <Box sx={{ px: { xs: 3, md: 4 }, py: 4 }}>
                  <Grid2 container spacing={3}>
                    {/* Email */}
                    <Grid2 xs={12}>
                      <FieldLabel
                        icon={<EmailIcon />}
                        label="Your Email Address"
                        color="#5C6BC0"
                      />
                      <TextField
                        fullWidth
                        placeholder="you@example.com"
                        variant="outlined"
                        value={email}
                        onChange={(e) => setemail(e.target.value)}
                        inputProps={{ maxLength: 50, type: "email" }}
                      />
                    </Grid2>

                    {/* Reason */}
                    <Grid2 xs={12}>
                      <FieldLabel
                        icon={<CategoryIcon />}
                        label="Reason for Contact"
                        color="#5C6BC0"
                      />
                      <FormControl fullWidth>
                        <Select
                          value={feature}
                          onChange={(e) => setfeature(e.target.value)}
                          displayEmpty
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                maxHeight: 200, 
                                overflowY: "auto",
                                borderRadius: 2,
                                boxShadow: '0 8px 30px rgba(92,107,192,0.12)',
                                border: '1px solid rgba(92,107,192,0.1)',
                              },
                            },
                          }}
                          renderValue={(val) => {
                            if (!val)
                              return (
                                <Typography
                                  color="#9AA6B9"
                                  fontSize="0.95rem"
                                >
                                  Select a topic…
                                </Typography>
                              );
                            const found = REASON_OPTIONS.find(
                              (o) => o.value === val,
                            );
                            return found
                              ? `${found.emoji}  ${found.label}`
                              : val;
                          }}
                        >
                          {REASON_OPTIONS.map((opt) => (
                            <MenuItem 
                              key={opt.value} 
                              value={opt.value}
                              sx={{
                                transition: 'all 0.2s ease',
                                '&:hover': {
                                  backgroundColor: `rgba(92,107,192,0.04)`,
                                  transform: 'translateX(4px)',
                                },
                              }}
                            >
                              <Box
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 1.5,
                                }}
                              >
                                <span style={{ fontSize: "1.2rem" }}>
                                  {opt.emoji}
                                </span>
                                <Typography fontWeight={500} color="#1A1D2E">
                                  {opt.label}
                                </Typography>
                              </Box>
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </Grid2>

                    {/* Message */}
                    <Grid2 xs={12}>
                      <FieldLabel
                        icon={<DescriptionIcon />}
                        label="Message"
                        color="#5C6BC0"
                      />
                      <TextField
                        fullWidth
                        placeholder="Tell us what's on your mind — we're all ears!"
                        variant="outlined"
                        multiline
                        rows={5}
                        value={message}
                        onChange={(e) => setmessage(e.target.value)}
                        inputProps={{ maxLength: 350 }}
                      />
                      <Typography
                        variant="caption"
                        color="#9AA6B9"
                        sx={{ mt: 0.5, display: "block", textAlign: "right" }}
                      >
                        {message.length}/350
                      </Typography>
                    </Grid2>

                    {/* Actions */}
                    <Grid2 xs={12}>
                      <Divider sx={{ mb: 2, borderColor: "rgba(92,107,192,0.08)" }} />
                      <Box
                        sx={{
                          display: "flex",
                          gap: 2,
                          justifyContent: "flex-end",
                        }}
                      >
                        <Button
                          variant="outlined"
                          onClick={handleGoBack}
                          sx={{
                            color: "#6B7280",
                            borderColor: "rgba(107,114,128,0.3)",
                            "&:hover": {
                              borderColor: "#EF5350",
                              color: "#EF5350",
                              backgroundColor: "rgba(239,83,80,0.02)",
                            },
                          }}
                        >
                          Cancel
                        </Button>
                        <Button
                          variant="contained"
                          endIcon={<SendIcon />}
                          onClick={handleSubmit}
                          sx={{
                            background: "linear-gradient(135deg, #5C6BC0, #7E8CD6)",
                            '&:hover': {
                              background: "linear-gradient(135deg, #4A5AAD, #6C7AC4)",
                            },
                          }}
                        >
                          Submit Ticket
                        </Button>
                      </Box>
                    </Grid2>
                  </Grid2>
                </Box>
              ) : (
                /* ── Success State ── */
                <Box
                  sx={{
                    px: 4,
                    py: 6,
                    textAlign: "center",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: 2,
                  }}
                >
                  <Avatar
                    sx={{
                      bgcolor: "rgba(76, 175, 80, 0.1)",
                      width: 72,
                      height: 72,
                      mb: 1,
                      animation: 'bounceIn 0.5s',
                      '@keyframes bounceIn': {
                        '0%': { transform: 'scale(0.3)', opacity: 0 },
                        '50%': { transform: 'scale(1.1)' },
                        '80%': { transform: 'scale(0.9)' },
                        '100%': { transform: 'scale(1)', opacity: 1 },
                      },
                    }}
                  >
                    <CheckCircleOutlineIcon
                      sx={{ fontSize: 40, color: "#4CAF50" }}
                    />
                  </Avatar>
                  <Typography
                    variant="h5"
                    fontWeight={800}
                    color="#1A1D2E"
                  >
                    Message Sent!
                  </Typography>
                  <Typography
                    variant="body1"
                    color="#6B7280"
                    maxWidth={320}
                  >
                    Thanks for reaching out. Our support team will get back to
                    you within 24 hours.
                  </Typography>
                  <Button
                    variant="contained"
                    onClick={handleReset}
                    sx={{
                      mt: 2,
                      background: "linear-gradient(135deg, #5C6BC0, #7E8CD6)",
                    }}
                  >
                    Send Another Message
                  </Button>
                </Box>
              )}
            </Paper>
          </Grid2>

          {/* ── Right: Illustration + Info Cards ──────────────────────── */}
          {!isMobileView && (
            <Grid2 xs={12} md={5} lg={6}>
              <Box
                sx={{
                  pl: { md: 2 },
                  animation: "slideInRight 0.5s ease-out 0.2s both",
                  '@keyframes slideInRight': {
                    from: {
                      opacity: 0,
                      transform: 'translateX(20px)',
                    },
                    to: {
                      opacity: 1,
                      transform: 'translateX(0)',
                    },
                  },
                }}
              >
                {/* Illustration box */}
                <Box
                  sx={{
                    borderRadius: 4,
                    overflow: "hidden",
                    mb: 3,
                    background: "rgba(255,255,255,0.5)",
                    p: 3,
                    display: "flex",
                    justifyContent: "center",
                    border: "1px solid",
                    borderColor: "rgba(92,107,192,0.1)",
                    backdropFilter: 'blur(10px)',
                    transition: 'all 0.3s ease',
                    '&:hover': {
                      transform: 'scale(1.02)',
                      boxShadow: '0 15px 35px rgba(92,107,192,0.1)',
                    },
                  }}
                >
                  <img
                    src={support_illustration}
                    alt="Support Illustration"
                    style={{ 
                      width: "85%", 
                      maxWidth: 340, 
                      display: "block",
                      filter: 'drop-shadow(0 8px 16px rgba(92,107,192,0.1))',
                    }}
                  />
                </Box>

                {/* Info cards */}
                <Grid2 container spacing={2}>
                  {[
                    {
                      emoji: "⚡",
                      title: "Fast Response",
                      desc: "Average reply time under 4 hours during business days.",
                      color: "#5C6BC0",
                      bgColor: "rgba(92,107,192,0.05)",
                    },
                    {
                      emoji: "🔒",
                      title: "Secure & Private",
                      desc: "Your data is encrypted and never shared.",
                      color: "#26C6DA",
                      bgColor: "rgba(38,198,218,0.05)",
                    },
                    {
                      emoji: "🌍",
                      title: "24/7 Coverage",
                      desc: "Global support team available around the clock.",
                      color: "#FFC107",
                      bgColor: "rgba(255,193,7,0.05)",
                    },
                  ].map((card) => (
                    <Grid2 xs={12} key={card.title}>
                      <Paper
                        elevation={0}
                        sx={{
                          p: 2.5,
                          borderRadius: 3,
                          border: "1px solid",
                          borderColor: "rgba(92,107,192,0.08)",
                          background: "rgba(255,255,255,0.8)",
                          backdropFilter: 'blur(10px)',
                          display: "flex",
                          alignItems: "flex-start",
                          gap: 2,
                          transition: "all 0.3s ease",
                          "&:hover": {
                            boxShadow: "0 10px 30px rgba(92,107,192,0.1)",
                            transform: "translateY(-2px)",
                            borderColor: card.color,
                          },
                        }}
                      >
                        <Box
                          sx={{
                            fontSize: "1.4rem",
                            width: 44,
                            height: 44,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            borderRadius: 2,
                            bgcolor: card.bgColor,
                            color: card.color,
                            flexShrink: 0,
                          }}
                        >
                          {card.emoji}
                        </Box>
                        <Box>
                          <Typography
                            variant="body1"
                            fontWeight={700}
                            color="#1A1D2E"
                          >
                            {card.title}
                          </Typography>
                          <Typography
                            variant="body2"
                            color="#6B7280"
                            mt={0.3}
                          >
                            {card.desc}
                          </Typography>
                        </Box>
                      </Paper>
                    </Grid2>
                  ))}
                </Grid2>
              </Box>
            </Grid2>
          )}
        </Grid2>
      </Box>
    </ThemeProvider>
  );
}

export default ContactUs;